import { OnInit, OnDestroy, Injectable, AfterViewInit } from '@angular/core';
import { fromEvent, Subject, Subscription } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { QueryParams } from '../models/query.params.model';
import { EventManagerService } from '../service/event-manager.service';
import { DialogService } from '../service/dialog.service';

@Injectable({ providedIn: 'root' })
export abstract class ManageComponent implements OnInit, OnDestroy, AfterViewInit {
  currentAccount: any | null = null;
  subscriptions?: Subscription[] = [];
  subsCommon?: Subscription[] = [];
  list?: any[] = [];
  extraData: any = {};
  params: any = {};
  queryParams: QueryParams;
  searchParams: any;
  selectedItem: any;
  deleteBoardcast: string;
  isCall: boolean = false;
  isExporting: boolean = false;
  isUpload: boolean = false;
  callApi$ = new Subject();
  callExport$ = new Subject();
  path: string = '';
  bodyInput: any = {};
  isBlockDrag: boolean = false;
  constructor(
    public eventManager: EventManagerService,
    public dialogService: DialogService,
  ) {

  }
  ngOnInit() {
    this.subscriptions = [];
    this.subsCommon =[
      this.eventManager.subscribe('load-page', (res) => {
        this.loadPage((res.content || {}).page || this.queryParams.page);
      }),
      this.eventManager.subscribe('upload-file', (res) => {
        this.isUpload = true;
      }),
      this.eventManager.subscribe('upload-fail', (res) => {
        this.isUpload = true;
      }),
      this.eventManager.subscribe('change-filter-start-end-date', (res) => {
        this.queryParams.page = 1;
        this.executeCallAPI();
      }),
    ];
    this.defaultParams();
    this.callApi$.pipe(
      debounceTime(500),
      ).subscribe((event)=> { return this.callAPI(event);});
    this.callExport$.pipe(
      debounceTime(500),
      ).subscribe((event)=> { return this.callExport(event);});
  }
  ngAfterViewInit(): void {
      
  }
  parseQueryParams(queryParams) {
    Object.keys(queryParams).forEach((key) => {
      if (key === 'page' || key === 'size') {
        this.queryParams[key] = queryParams[key] ? parseInt(queryParams[key]) : this.queryParams[key]
      } else {
        this.queryParams.searchParams[key] = queryParams[key];
      }
    });
    this.searchParams = Object.assign({}, this.queryParams.searchParams);
  }
  callAPI(event?) {
    this.loadAll();
  }
  executeCallAPI(event?) {
    this.callApi$.next(event || true);
  }
  export() {
    this.executeCallExport();
  }
  callExport(event?) {
  }
  executeCallExport(event?) {
    this.callExport$.next(event || true);
  }
  createBoardCastDelete(deleteBoardcast) {
    this.deleteBoardcast = deleteBoardcast;
    this.subscriptions.push(
      this.eventManager.subscribe(deleteBoardcast, (res) => {
        this.delete();
      })
    );
  }
  ngOnDestroy() {
    if (this.subscriptions.length > 0) {
      this.eventManager.destroys(this.subscriptions);
    }
    this.eventManager.destroys(this.subsCommon);
  }
  defaultParams() {
    this.list = [];
    this.queryParams = new QueryParams();
    this.searchParams = Object.assign({}, this.queryParams.searchParams);
  }
  checkChangeSearchParams() {
    const  isChange = Object.keys(this.queryParams.searchParams).some((properties) => {
      return this.queryParams.searchParams[properties] !== this.searchParams[properties];
    })
    if (isChange) {
      this.queryParams.page = 1;
      this.searchParams = Object.assign({}, this.queryParams.searchParams);
    }
    return this.queryParams;
  }
  trackId(index: number, item: any): number {
    return item.id;
  }
  trackIdentity(index: number, item: any) {
    return item.id;
  }
  loadPage(event: number) {
    const page = event;
    this.queryParams.page = page;
    if (page !== this.queryParams.previousPage) {
      this.queryParams.previousPage = page;
    }
    this.loadAll();
  }
  changePage(page) {
    this.queryParams.page = page;
    this.loadAll();
  }
  changeSize(size) {
    this.queryParams.page = 1;
    this.queryParams.size = size;
    this.loadAll();
  }
  checkDifferentBody(body) {
    body = body || {};
    return Object.keys(body).some((property) => {
      return body[property] !== this.bodyInput[property];
    });
  }
  loadAll(req?: any) {}
  sort(key, value) {
    this.searchParams.sort = {
      key,
      value
    }
    this.searchParams.sortField = key;
    this.searchParams.sortOrder = value;
    this.executeCallAPI();
  }
  createDebounceSearch(id) {
    const searchBox = document.getElementById(id);
    const keyup$ = fromEvent(searchBox, 'keydown');
    keyup$
      .pipe(
        map((i: any) => {}),
        debounceTime(2500)
      )
      .subscribe(() => {
        // this.loadAll();
      });
  }
  search(event) {
    this.eventManager.broadcast({
      name: 'get-value-search',
      content: {}
    });
  }
  getValueSearch(event) {
    this.queryParams.searchParams = event;
    const keys = Object.keys(this.queryParams.searchParams);
    keys.forEach((key) => {
      if (typeof this.queryParams.searchParams[key] === 'string') {
        this.queryParams.searchParams[key] = this.queryParams.searchParams[key].trim();
        if (this.queryParams.searchParams[key] === 'undefined' || this.queryParams.searchParams[key] === '') {
          this.queryParams.searchParams[key] = undefined;
        }
      }
    });
    this.loadPage(1);
  }
  eventSearchParams(key?, value?) {
    if (key) {
      this.searchParams[key] = value;
    }
    this.queryParams.page = 1;
    this.executeCallAPI();
  }
  delete() {
  }
  confirmDelete(selectedItem, title?) {
    this.selectedItem = selectedItem;
    // const modal = this.modalService.create({
    //   nzTitle: '',
    //   nzWidth: '650px',
    //   nzStyle: {top: '20px'},
    //   nzContent: ConfirmPopupComponent,
    //   nzComponentParams: {
    //     eventBroadcast: this.deleteBoardcast,
    //     title
    //   },
    //   nzOnOk: (() => { this.delete() })
    // });
  }
  confirmAction(selectedItem, title?, fowardFunc?) {
    this.selectedItem = selectedItem;
    // const modal = this.modalService.create({
    //   nzTitle: '',
    //   nzWidth: '650px',
    //   nzStyle: {top: '20px'},
    //   nzContent: ConfirmPopUpComponent,
    //   nzComponentParams: {
    //     title
    //   },
    //   nzOnOk: (() => { fowardFunc() })
    // });
  }
  dragAndScroll(id) {
    let pos = { top: 0, left: 0, x: 0, y: 0 };
    const ele = document.getElementById(id);
    if (!ele) {
      return;
    }
    ele.scrollTop = 100;
    ele.scrollLeft = 150;
    let isPress: boolean  = false;
    var mouseDownHandler = (e) => {
      isPress = true;
      pos = {
        // The current scroll
        left: ele.scrollLeft,
        top: ele.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
      };
      ele.style.cursor = 'grabbing';
      ele.style.userSelect = 'none';
    };
    var mouseMoveHandler = (e) => {
      if (!isPress || this.isBlockDrag) {
        return;
      }
      // How far the mouse has been moved
      const dx = e.clientX - pos.x;
      const dy = e.clientY - pos.y;

      // Scroll the element
      ele.scrollTop = pos.top - dy;
      ele.scrollLeft = pos.left - dx;
      console.log('ele.scrollTop: ', pos.top - dy);
      console.log('ele.scrollLeft: ', pos.left - dx);
    };
    const mouseUpHandler = () => {
      isPress = false;
      ele.style.cursor = 'grab';
    };
    document.addEventListener('mousedown', mouseDownHandler);
    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  }
}
